
import { isCouponApplicable } from '@/utils/subscriptions/is-coupon-applicable'

/**
 * Return the line total after applying the discount, the breakdown
 * and the discount amount applied for display purposes.
 * @param {*} array [total, breakdown] as returned by pricingPreview
 * @param {*} line subscription line with potential coupon and redemptions
 * @returns {*} [totalAfterDiscount, breakdown, discountAmount]
 */
export function applyLineDiscount ([total, breakdown], line) {
  const coupon = line.coupon

  if (!coupon || !isCouponApplicable(line)) {
    return [total, breakdown, 0]
  }

  if (coupon.discount_scheme === '%') {
    const discount = total * (Number(coupon.amount) / 100)
    return [total - discount, breakdown, discount]
  }

  if (coupon.discount_scheme === '$') {
    const discount = Math.min(Number(coupon.amount), total)
    return [total - discount, breakdown, discount]
  }

  return [total, breakdown, 0]
}